/**
 * Review Feature i18n Registration
 */

import { addLocaleMessages } from '@/i18n';
import zhCN from './locales/zh-CN';
import enUS from './locales/en-US';
import zhTW from './locales/zh-TW';
import jaJP from './locales/ja-JP';

addLocaleMessages('cn', { review: zhCN });
addLocaleMessages('en', { review: enUS });
addLocaleMessages('tw', { review: zhTW });
addLocaleMessages('jp', { review: jaJP });
